import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("rect", {
        x: "3",
        y: "3",
        width: "18",
        height: "4",
        rx: "1.5",
        fill: "currentColor"
      }),
      _createElementVNode("rect", {
        x: "3",
        y: "10",
        width: "18",
        height: "4",
        rx: "1.5",
        fill: "currentColor"
      }),
      _createElementVNode("rect", {
        x: "3",
        y: "17",
        width: "18",
        height: "4",
        rx: "1.5",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }